// plugins/encryptor.js
import CryptoJS from 'crypto-js';

const SECRET_KEY = "6fa979f20126cb08aa645a8f495f6d85";
const SEC_IV     = "I8zyA4lVhMCaJ5Kg";

export default {
  install(app) {
    app.config.globalProperties.$encryptData = (plainText) => {
      const key = CryptoJS.enc.Utf8.parse(SECRET_KEY);
      const iv = CryptoJS.enc.Utf8.parse(SEC_IV);

      const encrypted = CryptoJS.AES.encrypt(plainText, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });

      // Return full encrypted string with metadata (matches jQuery version)
      return encrypted.toString();
    };
  }
};
